/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidacyProfileEntryDestroy } from '../../axios/candidacyProfileEntryDestroy'
import type {
	CandidacyProfileEntryDestroyError,
	CandidacyProfileEntryDestroyPathParams,
	CandidacyProfileEntryDestroyResponse,
} from '../../types/CandidacyProfileEntryDestroy'

export const candidacyProfileEntryDestroyMutationKey = () =>
	[{ url: '/candidate-center/organisations/:organisation/candidacies/:candidacy/profile/:section/:entry' }] as const

export type CandidacyProfileEntryDestroyMutationKey = ReturnType<typeof candidacyProfileEntryDestroyMutationKey>

export type CandidacyProfileEntryDestroyVariables = {
	organisation: CandidacyProfileEntryDestroyPathParams['organisation']
	candidacy: CandidacyProfileEntryDestroyPathParams['candidacy']
	section: CandidacyProfileEntryDestroyPathParams['section']
	entry: CandidacyProfileEntryDestroyPathParams['entry']
}

/** @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidacyProfileEntryController.php CandidacyProfileEntryController::destroy */
export function useCandidacyProfileEntryDestroy<TContext = unknown>(
	options?: UseMutationOptions<
		CandidacyProfileEntryDestroyResponse,
		AxiosError<CandidacyProfileEntryDestroyError>,
		CandidacyProfileEntryDestroyVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidacyProfileEntryDestroyMutationKey(),
		mutationFn: ({ organisation, candidacy, section, entry }: CandidacyProfileEntryDestroyVariables) =>
			candidacyProfileEntryDestroy(organisation, candidacy, section, entry, config).then(res => res.data),
		...options,
	})
}
